const insideACity = (city, lat, lng) => {
    return city.boundaries.top.left.lat <= lat <= city.boundaries.top.right.lat &&
        city.boundaries.bottom.left.lat <= lat <= city.boundaries.bottom.right.lat
        && city.boundaries.top.left.lng <= lng <= city.boundaries.bottom.left.lng
        && city.boundaries.top.right.lng <= lng <= city.boundaries.bottom.right.lng;
};
const getCity = (cities, lat, lng) => {
    for (let i = 0; i < cities.length; i++) {
        let c = cities[i];
        if (insideACity(c, lat, lng)) {
            return c;
        }
    }
    return null;
};
const getCityByCoords = (cities, lat, lng) => {
    for (let i = 0; i < cities.length; i++) {
        let c = cities[i];
        if (insideBoundaries(c, { lat: lat, lng: lng })) {
            return c;
        }
    }
    return null;
};
const getCityById = (cities, id) => {
    for (let i = 0; i < cities.length; i++) {
        if (cities[i].id == id) {
            return cities[i];
        }
    }
    return null;
};
const getCityBySlug = (cities, slug) => {
    for (let i = 0; i < cities.length; i++) {
        if (cities[i].slug == slug) {
            return cities[i];
        }
    }
    return null;
};
function pointInPolygon(polySides, polyX, polyY, x, y) {
    let j = polySides - 1;
    let oddNodes = false;
    for (let i = 0; i < polySides; i++) {
        if (polyY[i] < y && polyY[j] >= y || polyY[j] < y && polyY[i] >= y) {
            if (polyX[i] + (y - polyY[i]) / (polyY[j] - polyY[i]) * (polyX[j] - polyX[i]) < x) {
                oddNodes = !oddNodes;
            }
        }
        j = i;
    }
    return oddNodes;
}
const insideBoundaries = (city, coords) => {
    let lat = coords.lat;
    let lng = coords.lng;
    let lats = [city.boundaries.top.left.lat, city.boundaries.top.right.lat, city.boundaries.bottom.right.lat, city.boundaries.bottom.left.lat, city.boundaries.top.left.lat]; // First point repeated to close polygon coordinates 
    let lngs = [city.boundaries.top.left.lng, city.boundaries.top.right.lng, city.boundaries.bottom.right.lng, city.boundaries.bottom.left.lng, city.boundaries.top.left.lng]; // First point repeated to close polygon coordinates 
    return pointInPolygon(4, lats, lngs, lat, lng);
};
export { insideACity, getCity, getCityById, getCityBySlug, getCityByCoords };
